export default __webpack_public_path__ + "static/media/LogoTaroGymnasiumSmall.83c1a960.svg";